export const featureAbbr = "notify"